<template>
  <div class="p-3 setting">
    <div class="page-header d-flex w-100">
      <div class="title-col d-flex w-50">
        <span class="title-text">
          Settings
          <small>( Change your account settings )</small>
        </span>
      </div>
    </div>
    <div class="page-body transparent-kendo-tab">
      <kendo-tabstrip class>
        <ul>
          <li class="k-state-active">Shift</li>
          <li>Roster</li>
          <li>Facility</li>
          <!-- <li>Preferences</li> -->
        </ul>
        <div class="pt-3 overflow-hidden">
          <Shift />
        </div>
        <div class="pt-3">
          <RosterSettings />
        </div>
        <div class="pt-3">
          <Facility />
        </div>
        <!-- <div class="pt-3">Preferences</div> -->
      </kendo-tabstrip>
    </div>
  </div>
</template>
<script>
// import Shift from "./../Shift/Shift.vue";
// import RosterSettings from "./../RosterSettings/RosterSettings.vue";
// import Facility from "./../Facility/Facility.vue";
export default {
  components: {
    // Shift,
    // RosterSettings,
    // Facility
  },
};
</script>
